export const colors = {
  greenPrimary: '#70C174',
  greenSecondary: '#BEF3C0',
  greenTertiary: '#EFF7F2',
  black: '#0B0706',
  primaryText: '#1D2130',
  secondaryText: '#525560',
  offWhite: '#EBF0F9',
  white: '#FFFFFF',
  border: '#E5E5E5',
};
